import Base from './base'

export default {
  get (seatClass) {
    return Base
      .get(`/webprice/seatclass/${seatClass}/prices`)
      .then(res => res.data)
      .then(res => res.reduce(function(acc, price) {
        if (price.materialId) {
          acc[price.materialId] = price
        }
        if (price.insertMaterialId) {
          acc[price.insertMaterialId] = price
        }
        return acc
      }, {}))
  }
}
